import * as React from 'react';
import { Organization, Task } from '../../types';
import { useOrganizations } from '../../state/context';
import TaskListItem from './TaskListItem';
import { TooltipProvider } from './Tooltip';

type TaskListProps = {
  tasks: Task[];
  isExpanded: boolean;
  includeOrganizationName?: boolean;
};

const getOrganizationNameById = (organizations: Organization[], organizationId: number) => {
  const organization = organizations.find(({ id }) => id === organizationId);
  return organization ? organization.name : undefined;
};

const TaskList = ({
  tasks,
  isExpanded,
  includeOrganizationName,
}: TaskListProps) => {
  const organizations = useOrganizations();

  return (
    <TooltipProvider>
      {tasks.map((task) => (
        <TaskListItem
          key={task.id}
          task={task}
          isExpanded={isExpanded}
          organizationName={
            includeOrganizationName
              ? getOrganizationNameById(organizations, task.organizationId)
              : undefined
          }
        />
      ))}
    </TooltipProvider>
  );
};

export default TaskList;
